import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from 'store';
import ThemeProvider from 'theme/ThemeProvider';
import bootConfig from 'utils/bootConfig';
import GlobalStyleOverrides from './GlobalStyleOverrides';
import BootConfigContext from './components/BootConfigContext/BootConfigContext';
import App from './App';

(async () => {
  if (process.env.NODE_ENV === 'development' && bootConfig.isMock) {
    const { default: makeMockServer } = await import('./server');
    makeMockServer({ environment: 'development' });
  }

  const rootElement = document.getElementById('spaRootContainer');
  if (!rootElement) {
    throw new Error('Root element "spaRootContainer" not found');
  }

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <Provider store={store}>
        <GlobalStyleOverrides />
        <ThemeProvider>
          <BootConfigContext.Provider value={bootConfig}>
            <App />
          </BootConfigContext.Provider>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>
  );
})().catch((error: unknown) => {
  throw error;
});
